import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { deleteCompetition } from '../api/Competitions';
import { useState } from 'react';
import Spinner from 'react-bootstrap/esm/Spinner';

function DeleteDraftModal(props) {
  const [loading, setLoading] = useState(false);
  const { competitionId, ...rest } = props;
  const navigate = useNavigate();

  const onDeleteDraft = async () => {
    setLoading(true);
    const result = await deleteCompetition(competitionId);
    if (result === 200) {
      props.onHide();
      setLoading(false);
      navigate('/organizer/competitions');
    }
  };

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Radera utkast</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Permanent radera utkastet? Du kan inte ångra den här åtgärden.
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button onClick={onDeleteDraft}>
          {loading ? (
            <>
              <Spinner
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
                className='me-2'
              />
              <span className='visually-hidden'>Loading...</span>
            </>
          ) : (
            <></>
          )}
          Radera
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteDraftModal;
